import React from 'react';
import styled from 'styled-components';
//import StarIcon from '@mui/icons-material/Star';
//import StarOutlineIcon from '@mui/icons-material/StarOutline';
import numeral from 'numeral';

import QualityFilledGreenSvg from 'shared/statics/svg/Quality-Filled-Green.svg';
import QualityEmptySvg from 'shared/statics/svg/Quality-Empty.svg';
import QualityFilledYellowSvg from 'shared/statics/svg/Quality-Filled-Yellow.svg';
import ArrowImg from 'shared/statics/svg/Stage-Arrow.svg';
import CapacityImg from 'shared/statics/svg/Stage-Capacity.svg';
import ReachImg from 'shared/statics/svg/Stage-Reach.svg';
import LearnImg from 'shared/statics/svg/Stage-Learn.svg';
import ActImg from 'shared/statics/svg/Stage-Act.svg';
import SucceedImg from 'shared/statics/svg/Stage-Succeed.svg';
import CatalyzeImg from 'shared/statics/svg/Stage-Catalyze.svg';

const RenderRow = ({ data, title, imageClass }) => {
  const activeStar = data.classification < 2 ? <StarIconYellow /> : <StarIcon />;
  const variance = numeral(data.variance).format('0');
  return <TableRow>
    <div>
      <ImageBox className={imageClass} />
      <h3>{title}</h3>
      <span>Social Impact</span>
      <ArrowDown />
    </div>
    <div>
      <h3>{data.title}</h3>
      <span className="spaced"><b>Description:</b> {data.description}</span>
      <span className="spaced"><b>Success Criteria:</b> {data.success_criteria}</span>
      <span className="spaced"><b>Sources/Assumptions:</b> {data.sources}</span>
    </div>
    <div>
      <Stars>
        <Star>
          {data.classification >= 1 ? activeStar : <StarOutlineIcon />}
        </Star>
        <Star>
          {data.classification >= 2 ? activeStar : <StarOutlineIcon />}
        </Star>
        <Star>
          {data.classification >= 3 ? activeStar : <StarOutlineIcon />}
        </Star>
      </Stars>
      <h3>{data.class_title}</h3>
      <span>{data.class_subtitle}</span>
    </div>
    <div>
      <Tag positive={variance >= 0}>{variance}%</Tag>
    </div>
  </TableRow>;
};

export const IrImpactModel = ({ impactModel }) => {
  return <Container>
    <Table>
      <Heading>
        <h2>Impact Model</h2>
        <p>Below is the grantee's summary of how this program/initiative generates value, including the criteria for success at each stage
        and the number of successes achieved (Indicator), where the data come from (Measurement), and, if relevant, how much the current
        numbers vary from the original forecast before implementation (Variance).</p>
      </Heading>
      <TableHeader>
        <div><span>Stage</span></div>
        <div><span>Indicator</span></div>
        <div><span>Data Quality</span></div>
        <div><span>Variance</span></div>
      </TableHeader>
      {(impactModel?.['5'].data || []).map((data, i) => <RenderRow key={i} data={data} title="Reached" imageClass="reach" />)}
      {(impactModel?.['1'].data || []).map((data, i) => <RenderRow key={i} data={data} title="Learn" imageClass="learn" />)}
      {(impactModel?.['2'].data || []).map((data, i) => <RenderRow key={i} data={data} title="Act" imageClass="act" />)}
      {(impactModel?.['3'].data || []).map((data, i) => <RenderRow key={i} data={data} title="Succeed" imageClass="succeed" />)}
    </Table>
  </Container>;
};

const Container = styled.div`
  width: 100%;
  height: 100%;
`;

const Table = styled.div`
  width: 100%;
  height: auto;
  min-height: 200px;
  background-color: #FFFFFF;
  border: solid 1px #ccd7e3;
  border-radius: 4px;
  padding-bottom: 20px; 
`;

const Heading = styled.div`
  padding: 20px;
  h2 {
    color: #595959;
    font-size: 24px;
    font-weight: 700;
  }
  p {
    color: #595959;
    font-size: 14px;
    font-weight: 400;
  }
`;

const TableHeader = styled.div`
  width: 100%;
  height: auto;
  padding-left: 20px;
  padding-right: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  display: flex;
  flex-direction: row;
  div {
    border-left: 1px solid #ccd7e3;
    padding-left: 5px;
    span {
      font-size: 16px;
      color: #595959;
      font-weight: 700;
    }
  }
  div:nth-child(1) {
    flex: 1;
    border-left: none;
  }
  div:nth-child(2) {
    flex: 4;
  }
  div:nth-child(3) {
    flex: 3;
  }
  div:nth-child(4) {
    flex: 1;
  }
`;

const TableRow = styled.div`
  width: 100%;
  height: auto;
  min-height: 250px;
  padding: 20px;
  background-color: #f5f8fa;
  border-top: solid 1px #ccd7e3;
  border-bottom: solid 1px #ccd7e3;
  display: flex;
  flex-direction: row;
  div {
    padding-right: 10px;
    box-sizing: border-box;
    h3 {
      font-size: 16px;
      color: #595959;
      font-weight: 700;
      margin-top: 5px;
      margin-bottom: 0;
    }
    span {
      font-size: 14px;
      color: #595959;
      font-weight: 400;
    }
    b {
      color: #595959;
    }
    span.spaced {
      display: block;
      margin-top: 10px;
      margin-bottom: 10px;
    }
  }
  div:nth-child(1) {
    flex: 1;
    border-left: none;
    position: relative;
  }
  div:nth-child(2) {
    flex: 4;
  }
  div:nth-child(3) {
    flex: 3;
  }
  div:nth-child(4) {
    flex: 1;
  }
`;

const ImageBox = styled.div`
  width: 40px;
  height: 40px;
  &.capacity {
    background-image: url(${CapacityImg});
    background-size: cover;
  }
  &.reach {
    background-image: url(${ReachImg});
    background-size: cover;
  }
  &.learn {
    width: 47px;
    height: 33px;
    background-image: url(${LearnImg});
    background-size: cover;
  }
  &.act {
    background-image: url(${ActImg});
    background-size: cover;
  }
  &.succeed {
    background-image: url(${SucceedImg});
    background-size: cover;
  }
  &.catalize {
    background-image: url(${CatalyzeImg});
    background-size: cover;
  }
`;

const ArrowDown = styled.div`
  background-image: url(${ArrowImg});
  background-size: cover;
  width: 32px;
  height: 98px;
  position: absolute;
  bottom: 0;
  left: 0px;
`;

const Stars = styled.div`
  height: 40px;
`;

const Star = styled.div`
  width: 33px;
  height: 33px;
  box-sizing: border-box;
  margin-right: 3px;
  float: left;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 0px !important;
  -webkit-print-color-adjust: exact;
`;

const Tag = styled.div`
  width: 85px;
  height: 32px;
  padding: 4px;
  font-size: 14px;
  font-weight: 400;
  background-color: ${props => props.positive ? '#cdedcd' : '#fcd7d9'};
  color: ${props => props.positive ? '#005F40' : '#d15b5c'};
  text-align: center;
  border-radius: 16px;
  padding-right: 4px !important;
  text-align: center;
`;

const StarIcon = styled.div`
  width: 33px;
  height: 33px;
  background-image: url(${QualityFilledGreenSvg});
  background-size: cover;
`;

const StarOutlineIcon = styled.div`
  width: 33px;
  height: 33px;
  background-image: url(${QualityEmptySvg});
  background-size: cover;
`;

const StarIconYellow = styled.div`
  width: 33px;
  height: 33px;
  background-image: url(${QualityFilledYellowSvg});
  background-size: cover;
`;